import { useForm } from 'react-hook-form';

export const useFormHelper = () => {
  const {
    watch,
    reset,
    control,
    setValue,
    getValues,
    handleSubmit,
    register,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  return {
    watch,
    reset,
    control,
    setValue,
    getValues,
    register,
    handleSubmit,
    setError,
    errors,
  };
};
